import _ from 'lodash'
import { PROPOSAL_REVIEW_STATUS, PROPOSAL_PHASE_TYPE, PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { HistoryUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'

const editableStatusSetMap = new Set([
  PROPOSAL_REVIEW_STATUS.DRAFT,
  PROPOSAL_REVIEW_STATUS.COMPOSING
])

const getPhaseByUrl = match => _.get(match, 'params.phase', null)
const getFeatureByUrl = match => _.get(match, 'params.feature', null)

export const updateHistoryAfterProposalSaved = (props, formData) => {
  const { match } = props
  const phaseByUrl = getPhaseByUrl(match)
  const feature = getFeatureByUrl(match)

  const {
    id,
    reviewStatus
  } = formData

  switch (phaseByUrl) {
    case PROPOSAL_PHASE_TYPE.COMPOSE: {
      if (editableStatusSetMap.has(reviewStatus)) {
        // 若為複製賣場後儲存草稿，取得提案單號後網址須變為 /proposal/newListing/compose?id={id}
        if (feature === PROPOSAL_TYPE.CLONE_LISTING) {
          const currentUrl = window.location.href
          const newUrl = currentUrl.replace(PROPOSAL_TYPE.CLONE_LISTING, PROPOSAL_TYPE.NEW_LISTING)
          window.history.pushState({}, '', `${newUrl}&id=${id}`)
        } else {
          HistoryUtil.updateHistory({ id })
        }
      }
      break
    }
  }
}
